import { Shield, Clock, Star, Users, Headphones } from "lucide-react";
import { useTheme } from "@/components/ThemeContext";
import ScrollReveal from "@/components/ScrollReveal";

const whyUs = [
  { icon: Users, title: "Autisti Professionisti", desc: "Esperti, discreti e sempre impeccabili nel servizio" },
  { icon: Shield, title: "Veicoli di Alta Gamma", desc: "Flotta Mercedes costantemente rinnovata" },
  { icon: Clock, title: "Puntualità Garantita", desc: "Il vostro tempo è la nostra priorità assoluta" },
  { icon: Star, title: "Servizio su Misura", desc: "Ogni dettaglio è pensato per le vostre esigenze" },
  { icon: Headphones, title: "Disponibilità H24", desc: "24 ore su 24, 7 giorni su 7" },
];

export default function WhyUsSection() {
  const { isDark } = useTheme();

  return (
    <section data-testid="why-us-section" className={`py-20 md:py-32 transition-colors duration-500 ${isDark ? "bg-[#0E0E0E]" : "bg-[#EDE8DC]"}`}>
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <ScrollReveal>
          <span className="text-xs font-medium tracking-[0.2em] uppercase text-[#C9A646] block mb-4">Perché Sceglierci</span>
          <h2 className={`text-2xl sm:text-3xl lg:text-4xl tracking-tight font-normal mb-16 ${isDark ? "text-white" : "text-[#1A1A1A]"}`}>
            Il lusso della<span className="italic text-[#C9A646]"> puntualità</span>
          </h2>
        </ScrollReveal>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-4">
          {whyUs.map((item, i) => {
            const Icon = item.icon;
            return (
              <ScrollReveal key={item.title} delay={i * 0.08}>
                <div className="text-center p-6 md:p-8 group">
                  <div className="inline-flex items-center justify-center w-14 h-14 border border-[#C9A646]/30 mb-5 group-hover:border-[#C9A646] group-hover:bg-[#C9A646]/10 transition-all duration-500">
                    <Icon className="w-6 h-6 text-[#C9A646]" strokeWidth={1.5} />
                  </div>
                  <h3 className={`text-base font-medium mb-2 ${isDark ? "text-white" : "text-[#1A1A1A]"}`}>{item.title}</h3>
                  <p className={`text-sm leading-relaxed ${isDark ? "text-[#A1A1AA]" : "text-[#666]"}`}>{item.desc}</p>
                </div>
              </ScrollReveal>
            );
          })}
        </div>
      </div>
    </section>
  );
}
